<template>
    <div class="p-3 p-md-5">
        <div class="row">
            <div class="col-12">
            <div class="row">
                <div class="col-12 col-lg-5 my-4" v-if="userProfile.role === 'super_admin'">
                    <label>Events</label>
                    <select class="form-control" @change="selEventChange" v-model="selEvent">
                        <option v-for="conf in confList" :key="conf.id" :value="conf.id">{{conf.data.confname}}</option>
                    </select>
                </div>
                <div class="col-12 my-4">
                    <h3 class="text-primary">{{confData.confname}}</h3>
                </div>
                <!-- <div class="col-12 col-lg-3 order-lg-last">
                    <div class="row">
                        <div class="col-12 col-sm-4 col-lg-12 my-2">
                            <div class="card bg-warning text-white">
                                <div class="card-body" align="center">
                                    <p>Registrations</p>
                                    <h5 v-if="confTickets === '' && confPaymentStatus === ''">
                                    {{registrations.length}}
                                    </h5>
                                    <h5 v-if="confTickets !== '' || confPaymentStatus !== ''">
                                    {{filterTickets.length}} /{{registrations.length}}
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4 col-lg-12 my-2">
                            <div class="card bg-primary text-white">
                                <div class="card-body" align="center">
                                    <p>Payments</p>
                                    <h5 class="">
                                    {{income}}
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4 col-lg-12 my-2">
                            <div class="card bg-primary text-white">
                                <div class="card-body" align="center">
                                    <p>Event starts in</p>
                                    <h5 class="">
                                    {{ confData.confstartdate | moment("from", "now", true) }}
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="col-12 col-lg-12 ">
                    <div class="row">
						<div class="col-12 col-md-10 my-2">
                            <label>Search registrations</label>
                            <input type="text" class="form-control" placeholder="Search" :value="txtSearch" @input="e => txtSearch = e.target.value" />
                        </div>
                        <div class="col-12 col-md-3 my-2">
                            <label>Filter registrations</label>
                            <select class="form-control" v-model="confTickets">
                                <option value="">VIEW ALL</option>
                                <option v-for="ticket in tickets" :value="ticket.id" :key="ticket.id">{{ticket.data.name}}</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-3 my-2">
                            <label>Payment status</label>
                            <select class="form-control" v-model="confPaymentStatus">
                                <option value="">VIEW ALL</option>
                                <option value="PAID">PAID</option>
								<option value="REGISTERED">REGISTERED</option>
                            </select>
                        </div>
						<div class="col-12 col-md-3 my-2">
                            <label>Hotel</label>
                            <select class="form-control" v-model="confHotel">
                                <option value="">VIEW ALL</option>
                                <option v-for="(hotel, index) in confData.confhotel" :value="hotel" :key="index">{{hotel}}</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-3 my-3">
							<div class="dropdown mt-md-4">
								<button type="button" class="btn btn-outline-primary dropdown-toggle btn-block" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
								<div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
									<button @click="btnExportClick" class="btn btn-link text-reset dropdown-item">Export selected</button>
									<div class="dropdown-divider"></div>
									<button class="btn btn-link text-reset dropdown-item" @click="componentKey = Math.floor(Date.now()/1000)" data-toggle="modal" data-target="#sendMessageModal">Send a message to selected</button>
									<div class="dropdown-divider"></div>
									<button class="btn btn-link text-reset dropdown-item">Download ALL vaccination cards</button>
								</div>
							</div>
                        </div>
						<div class="col-12 col-md-3 my-3 bold">
							Showing: {{filterTickets.length}} /{{registrations.length}} records
						</div>
                        <div class="col-12 my-2">
                            <v-table
                                :data="sales"
                                :currentPage.sync="currentPage"
                                :pageSize="10"
                                @totalPagesChanged="totalPages = $event"
                                width="100%"
                                cellpadding="10"
                                border="1"
                                style="border: 1px solid #e1e1e1;"
                            >
                                <tr slot="head" class="bg-light">
                                    <th width="12%">Date</th>
									<th>Order Ref.</th>
                                    <th>Contact</th>
                                    <!-- <th>Club</th> -->
                                    <th>Ticket</th>
									<th>Flight/Hotel</th>
									<th>Docs</th>
                                    <!-- <th>Actions</th> -->
                                </tr>
                                <tbody slot="body" slot-scope="{displayData}">
                                    <tr v-if="sales.length < 1"><td align="center" colspan="6"><em>No data to show...</em></td></tr>
                                    <tr v-for="row in displayData" :key="row.guid">
                                        <td>{{ String(row.data.added.toDate()).slice(4,15) }}</td>
										<td><a class="dropdown-item pointer text-primary" @click="btnEditClick(row.id, row.data)" data-toggle="modal" data-target="#editRegistrationModal">{{ row.data.orderid }}</a></td>
                                        <td>
											<strong>{{ row.data.fname.toUpperCase() }} {{ row.data.lname.toUpperCase() }}</strong>
											<br/>{{ row.data.email.toLowerCase() }}<br/> {{ row.data.phone }}
											<br/>-----
											<br/>{{ row.data.club.toUpperCase() }}
										</td>
                                        <!-- <td>{{ row.data.club.toUpperCase() }}</td> -->
                                        <td>{{ row.data.confticket }} 
											<span v-if="row.data.status === 'PAID'" class="badge bg-success text-white">{{ row.data.status }}</span>
											<span v-if="row.data.status === 'CANCELLED'" class="badge bg-danger text-white">{{ row.data.status }}</span>
											<span v-if="row.data.status === 'REGISTERED'" class="badge bg-warning text-white">{{ row.data.status }}</span>
										</td>
										<td> 
											<span v-if="row.data.confhotel">
											{{row.data.confhotel}}
											<br/>---
											<br/>{{row.data.confflight1}} - {{row.data.confarrdate}} {{row.data.confarrtime}}
											<br/>{{row.data.confflight2}} - {{row.data.confdepdate}} {{row.data.confdeptime}}
											</span>
											<span v-else>NOT PROVIDED</span>
										</td>
										<td> 
											<a class="" target="_vaxx" :href="row.data.imgFile" v-if="row.data.imgFile">VACCINATION CARD</a>
											<span v-else>NOT PROVIDED</span>
										</td>
                                        <!-- <td align="center"> 
                                            <div class="dropdown">
                                                <button type="button" class="btn btn-sm btn-link" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-ellipsis-h"></i></button>
                                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item pointer" @click="btnEditClick(row.id, row.data)" data-toggle="modal" data-target="#editRegistrationModal">View or edit registration</a>
                                                    <a class="dropdown-item pointer" >Send a message</a>
													<a class="dropdown-item pointer" target="_vaxx" :href="row.data.imgFile" >View vaxx information</a>
                                                </div>
                                            </div>
                                        </td> -->
                                    </tr>
                                </tbody>
                            </v-table>
							<smart-pagination class="my-2"
                                :currentPage.sync="currentPage"
                                :totalPages="totalPages"
                            />
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>

		<!-- Modal -->
		<div class="modal fade" id="editRegistrationModal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title mkt-title" >Edit Registration</h4>
						<button type="button" id="btnCloseRegistrationModal" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="padding:1rem 3rem">
						<div class="row">
							<div class="col-12">
								<RegistrationForm  :activeData="activeData" :activeId="activeId" :key="componentKey"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="modal fade" id="sendMessageModal" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title mkt-title" >Send Message</h4>
						<button type="button" id="btnCloseMessageModal" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="padding:1rem 3rem">
						<div class="row">
							<div class="col-12">
								<SendMessageForm  :mailingList="sales" :key="componentKey"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>


    </div>
</template>

<script>
import RegistrationForm from '../components/RegistrationForm.vue'
import SendMessageForm from '../components/SendMessageForm.vue'
const fb = require("../firebaseConfig")
export default {
    name: "Admin",
    components: {
        RegistrationForm, SendMessageForm
    },
    computed:{
        confList(){
        return this.$store.state.confList
        },
        confData(){
            return Array.isArray(this.confList) && this.confList.length > 0 ? this.confList.filter((c) => c.id === this.confId )[0].data : {}
        },
        filterTickets(){
            if(this.confTickets === "" && this.confPaymentStatus == "" && this.confHotel == "") return this.registrations;
			let filteredRegs = this.registrations;
			if(this.confTickets !== "") filteredRegs = filteredRegs.filter((r) => r.data.confticketid === this.confTickets)
			if(this.confPaymentStatus !== "") filteredRegs = filteredRegs.filter((r) => r.data.status === this.confPaymentStatus)
			if(this.confHotel !== "") filteredRegs = filteredRegs.filter((r) => r.data.confhotel === this.confHotel)

			return filteredRegs;
        },
        sales(){
            if(this.txtSearch.length<3) return this.filterTickets
            const txtSearch = this.txtSearch.toLowerCase()
            const filter = (r) => {
                return (
                    r.data.fname.toLowerCase().includes(txtSearch) ||
                    r.data.lname.toLowerCase().includes(txtSearch) ||
                    r.data.email.toLowerCase().includes(txtSearch) ||
                    r.data.phone.toLowerCase().includes(txtSearch) ||
                    r.data.confticket.toLowerCase().includes(txtSearch) ||
                    r.data.club.toLowerCase().includes(txtSearch) 
                )
            }
            return this.filterTickets.filter(filter)
        },
        income(){
            const income = this.registrations.reduce((acc, val)=>{
                return val.data.confticketprice ? acc + Number(val.data.confticketprice) : acc
            }, 0)
            return Number(income).toLocaleString("en-US",{style: "currency", currency:"USD"})
        },
        userProfile(){
            console.log(this.$store.state.userProfileDoc)
            return this.$store.state.userProfile
        },
    },
    data(){
        return{
            tickets:[],
            confId: "",
			confHotel:"",
            registrations: [],
            currentPage: 1,
            totalPages: 0,
            txtSearch:"",
            confTickets:"",
			confPaymentStatus:"",
            selEvent:"",
			activeId: "",
			activeData: "",
			componentKey: "",
        }
    },
    methods:{
        btnExportClick(){
            const csvString = [
                ['DATE', 'REF', 'NAME', 'CONTACT', 'CLUB', 'CLUB ROLE', 'TICKET', 'STATUS', 'GENDER', 'T-SHIRT', 'BOOKLET', 'DIET', 'SPECIAL REQ.', 'HOTEL', 'ARR. AIRLINE', 'ARR. FLIGHT', 'ARR. DATE', 'ARR. TIME', 'DEP. AIRLINE', 'DEP. FLIGHT', 'DEP. DATE', 'DEP. TIME', 'VACC. INFO', 'E-CONTACT'],
                ...this.sales.map((row) => [
                    encodeURI(row.data.added.toDate()),
                    encodeURI(row.id),
                    encodeURI(`${row.data.fname.toUpperCase()} ${row.data.lname.toUpperCase()}`),
                    encodeURI(`${row.data.email.toLowerCase()} / ${row.data.phone}`),
                    encodeURI(row.data.club.toUpperCase()),
                    encodeURI(row.data.club_role),
                    encodeURI(row.data.confticket.toUpperCase()),
                    encodeURI(row.data.status.toUpperCase()),
                    encodeURI(row.data.gender.toUpperCase()),
                    encodeURI(row.data.tshirt ? row.data.tshirt : ""),
                    encodeURI(row.data.booklet ? row.data.booklet : ""),
                    encodeURI(row.data.dietsubject ? row.data.dietsubject : ""),
                    encodeURI(row.data.reqsubject ? row.data.reqsubject : ""),
					encodeURI(row.data.confhotel ? row.data.confhotel : ""),
					encodeURI(row.data.confairline1 ? row.data.confairline1 : ""),
					encodeURI(row.data.confflight1 ? row.data.confflight1 : ""),
					encodeURI(row.data.confarrdate ? row.data.confarrdate : ""),
					encodeURI(row.data.confarrtime ? row.data.confarrtime : ""),
					encodeURI(row.data.confairline2 ? row.data.confairline2 : ""),
					encodeURI(row.data.confflight2 ? row.data.confflight2 : ""),
					encodeURI(row.data.confdepdate ? row.data.confdepdate : ""),
					encodeURI(row.data.confdeptime ? row.data.confdeptime : ""),
					encodeURI(row.data.imgFile ? row.data.imgFile : ""),
                    encodeURI(row.data.ename ? `${row.data.ename } / ${row.data.ephone} / ${row.data.erelation}` : ""),
                ]),
            ].map((e) => e.join(',')).join('\n')

            const csvContent = 'data:text/csv;charset=utf-8,' + csvString;
            const d = new Date();
            const link = document.createElement('a')
            link.setAttribute('href', csvContent)
            link.setAttribute(
                'download',
                `registrations_${d.getFullYear()}-${
                    d.getMonth() + 1
                }-${d.getDate()}_${d.getHours()}${d.getMinutes()}${d.getSeconds()}.csv`
            )
            document.body.appendChild(link)
            link.click()
        },
        selEventChange(){
            location.href = `/admin/${this.selEvent}`
        },
		btnEditClick(id, data){
			this.componentKey = Math.floor(Date.now()/1000);
			this.activeId = id;
			this.activeData = data;
		}
    },
    mounted(){
        const confId = this.$route.params.id
        this.confId = this.selEvent = confId
        fb.ordersCollection.where("confeventid", "==", confId).onSnapshot((querySnapshot)=>{
            let registrations = []
            querySnapshot.forEach((doc)=>{
                registrations = [...registrations, {id: doc.id, data: doc.data()}]
            })
            this.registrations = registrations.sort((a,b) => a.id > b.id ? -1 : a.id < b.id ? 1 : 0)
        })
        fb.confticketsCollection.where("eventid", "==", confId).onSnapshot((querySnapshot)=>{
            let tickets = []
            querySnapshot.forEach((doc)=>{
                tickets = [...tickets, {id: doc.id, data: doc.data()}]
            })
            this.tickets = tickets.sort((a,b) => a.id > b.id ? -1 : a.id < b.id ? 1 : 0)
        })
    }
}
</script>
